<template>
<div id="mainBlock">
    <div id="blackPanel"></div>
    <article>
        <section>
            <div id="subHeader">

                <!-- 企業名を表示 -->
                <h2 v-if="siteInfo !== null">{{siteInfo[0]['site_name']}}</h2>

                <!-- 実行結果のモーダル -->
                <Alert
                    ref="Alert"
                    :message="alertMessage"
                    :subMessage="alertSubMessage"
                    :errorFlag="errorFlag"
                    @confirmFinished="confirmFinished"
                />

                <div class="controller">
                    <!-- カメラを選択 -->
                    <div class="select_device">
                        <select name="view_device" class="device"  v-model="selectedCamera" id="cameraSelect" @change='defaultSelected = false, disabledDateChange()'>
                            <option v-if="Object.keys(cameraInfo).length > 1" value='' disabled selected style='display:none;'>カメラを選択</option>
                            <option v-for="(cameralists, key) in cameraInfo" :key="key" :value="cameralists.term_id + ',' + cameralists.description">{{cameralists.description}}</option>
                        </select>
                    </div>
                    <!-- 日付を選択 -->
                    <div class="select_date">
                        <div class="datepicker" id="datepicker_focus_check">

                            <!-- Datepickerを表示 -->
                            <vuejs-datepicker
                                class="datepicker_dp"
                                readonly="true"
                                placeholder="日付を選択"
                                v-model="trackedDate"
                                @input="formatPicker()"
                                :disabled = defaultSelected
                                format='yyyy/MM/dd'
                                :language="ja"
                                :disabled-dates="disabledDates"
                                :maximum-view="'day'"
                                :minimum-view="'day'"
                                :initial-view="'day'"
                                ref="picker"
                            ></vuejs-datepicker>

                        </div>
                    </div>

                    <div class="view_apply">
                        <input type="submit" value="適用" v-on:click="getThumnailImageInfo(siteInfo[0]['site_no'])">
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div id="cameraList">
                <!-- 履歴の動画一覧 -->
                <HistoryMovieLists
                    v-if="siteInfo !== null && cameraInfo !== null"
                    @loadStart="loadStart"
                    @finished="loadedMovie"
                    :selectedCameraInfo="selectedCameraInfo"
                    :historyList="historyList"
                    :timeStartUnixtime="timeStartUnixtime"
                    :is_onedayDownloadButton="is_onedayDownloadButton"
                    :mediaFilesize="mediaFilesize"
                    @modalOpen="modalOpen"
                    :isActiveListMovie="isActiveListMovie"
                    @isActiveMultiSelect="isActiveMultiSelect"
                    :siteInfo="siteInfo"
                    :is_thumbnailHourCount="is_thumbnailHourCount"
                    @changeContinuousReproductionOption="changeContinuousReproductionOption"
                    @showResultMessage="showResultMessage"
                    ref="movieLists"
                />

                <!-- ライブ再生モーダル -->
                <LiveModal
                    v-if="siteInfo !== null && cameraInfo !== null && modal"
                    :videoUrlList="videoUrlList"
                    :selectedMovie="selectedMovie"
                    :selectVideo="selectVideo"
                    :calledComponentName="calledComponentName"
                    @close="modalClose"
                    @checkEndedMovie="checkEndedMovie"
                    @checkBackMovie="checkBackMovie"
                    @showResultMessage="showResultMessage"
                />
            </div>
        </section>
    </article>
</div>
</template>
<script></script>
<script>
const apiUrl = process.env.VUE_APP_API_apiUrl;

import vuejsDatepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale'
import HistoryMovieLists from './HistoryMovieLists'
import LiveModal from '../modal/LiveModal'
import componentHistoryTabSwitcher from '../../js/modules/componentHistoryTabSwitcher.js'
import componentScrollControl from '../../js/modules/componentScrollControl.js'
import componentModalCenter from '../../js/modules/componentModalCenter.js'
import Alert from '../modal/Alert'
import componentUrlControl from '../../js/modules/componentUrlControl.js'
const logoutUrl = process.env.VUE_APP_TOP_PAGE_URL;

export default {
    name: 'HistoryMain',
    data() {
        return {
            // 選択した端末の端末IDおよびLIVE映像を格納
            selectVideo: {},

            // LiveModal.vueコンポーネントにどこからコールされたか判断できるようにするための変数
            calledComponentName: "HistoryMain",

            // 複数選択の有無を判定
            is_multiSelect: false,

            // ウィンドウのサイズを保持するために使用
            height: window.innerHeight,

            // プラン日数を格納するための変数
            planDate: Number,

            // vue-datepickerの設定
            ja: ja,
            disabledDates: {
                // datepickerは初期表示時に端末の数だけ現在日時の月をcreateする
                // 前の月や次の月を表示するときに、現在表示してある月の日付情報をdestroyし、指定した月の分をcreateする
                // create時に以下の関数が実行される
                // date：端末の数だけ指定した月の日付情報をDate型で格納される
                customPredictor: (date) => {
                    // プラン期間外の日付は非活性にする
                    // 1日プランであれば、2日前までを活性にする
                    var retentionDate = new Date()
                    retentionDate.setDate(retentionDate.getDate()-(this.planDate+1))
                    if(date < retentionDate && retentionDate.toString() !== "Invalid Date") {
                        return true
                    }

                    // 現在日時以降の日付は非活性にする
                    var today =  new Date();
                    if(today < date) {
                        return true
                    }
                }
            },

            // selectタグで選択された、カメラ名称とカメラIDを格納した配列一時格納場所
            selectedCamera: '',

            // selectタグで選択された、種別を格納した配列一時格納場所(ICSは静止画が不要なのでdefault値はmovie)
            selectedType: 'movie',

            // selectタグで選択された、カメラ名称とカメラIDを格納した配列
            // 表示デバイス、カメラ選択情報を格納する値、また動画再生のための値参照としても利用
            // [0]：カメラID、[1]：カメラ名称
            selectedCameraInfo: [],

            // datepickerで使用する値
            trackedDate: '',
            formattedDate: '',

            // サムネイル一覧情報の配列
            historyList : [],

            // 連続再生するための動画URL取得するAPIで取得した動画RULの配列
            videoContinuousPlayList : [],

            // 動画再生のために、モーダルに渡す動画URL情報の配列
            videoUrlList : [],

            // 動画再生のために選択された動画を特定するための値
            selectedMovie : null,

            // モーダルの開閉に使用するための値
            modal: false,

            // 静止画タブが選択されているか判断するための値
            isActiveListImage: false,

            // 動画タブが選択されているか判断するための値
            isActiveListMovie: true,

            // 時間単位でサムネイル数が存在する場合にカウントした値を格納
            is_thumbnailHourCount: 0,

            // 連続再生が有効か判断
            is_continuousReproduction: false,

            // 動画の再生終了を判断(連続再生中の動画を進めるか判断)
            is_endedMovie: false,

            // 連続再生中の動画を戻すか判断
            is_backMovie: false,

            // 実行結果のモーダル関連
            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false,

            // 実行確認モーダルの結果を格納
            conrfirmResult: {},

            // axios実行時のエラーに対してログアウトさせるか判断
            transitionLogoutPageFlg: false,

            // axios実行時のエラーに対してホーム画面に遷移させるか判断
            transitionTopPageFlg: false,

            // 選択した動画情報を格納
            selectVideoModalOpen: {},

            // 適用ボタン押下時の日付をunixtimeで格納
            timeStartUnixtime: null,

            // 1日ダウンロードのボタンを有効にするか無効にするか判断する値
            is_onedayDownloadButton: false,

            // 一括ダウンロードボタンを押下時にファイルサイズを取得して格納
            mediaFilesize: '―GB',

            // 端末が選択されていないときは非活性にする
            defaultSelected: true,

            // 日付選択を行うために指定されているカメラ端末情報
            temporarySelectedCamera: [],
        }
    },
    props:{
        siteInfo:{
            type: Array
        },
        cameraInfo:{
            type: Array
        }
    },
    components: {
        'vuejs-datepicker': vuejsDatepicker,
        HistoryMovieLists,
        LiveModal,
        Alert,
    },
    methods: {
        /****************************************************************/
        // 複数選択が有効/無効の状態を保持
        /****************************************************************/
        isActiveMultiSelect(is_active) {
            this.is_multiSelect = is_active;
        },
        /****************************************************************/
        // datepickerを非表示
        /****************************************************************/
        closeDatepicker() {
            this.$refs.picker.close(true);
        },
        /****************************************************************/
        // スマホの場合にdatepcikerを画面中央に表示
        /****************************************************************/
        handleResize() {
            this.$nextTick(function () {
                this.height = window.innerHeight;
                var target = document.querySelectorAll(".vdp-datepicker .vdp-datepicker__calendar");
                if (window.innerWidth < 1024) {
                    for (var i = 0; i < target.length; i++) {
                        target[i].style.top = this.height / 2 + "px";
                        target[i].style.transform = "translate(-50%, -50%)";
                        target[i].style.left = "50%";
                    }
                } else {
                    for (var i = 0; i < target.length; i++) {
                        target[i].style.top = "";
                        target[i].style.transform = "";
                        target[i].style.left = "";
                    }
                }
            })
        },
        /****************************************************************/
        // ローディングを開始する処理
        /****************************************************************/
        loadStart() {
            scrollTo(0, 0); // DL中は画面上部に移動(スクロールバーが途中だとローディングアイコンが中央寄せにならないため)
            this.$emit('loadStart');
        },

        /****************************************************************/
        // サムネイルを全て読み込み後にローディングを終了する処理(動画)
        /****************************************************************/
        loadedMovie() {
            this.$emit('loadFinish');

            // URLのパラメータにモーダル関係のparameterが含まれている場合にモーダルを開く
            if (Object.keys(this.selectVideoModalOpen).length > 0) {
                this.modalOpen(this.selectVideoModalOpen);
                this.selectVideoModalOpen = {};
            }
        },
        /****************************************************************/
        // datepickerの<vuejs-datepicker>タグvalue値をフォーマットする処理
        // 指定した日付をフォーマットする処理
        /****************************************************************/
        formatPicker() {
            var self = this;
            // object型からDate型に変換
            var d = new Date(self.trackedDate);

            // ブラウザのタイムゾーンで日時生成
            // var d = new Date();
            // yyyy/mm/ddのフォーマットに変更
            self.formattedDate =  d.getFullYear() + "/" + ("0"+(d.getMonth()+1)).slice(-2) +"/"+ ("0"+ d.getDate()).slice(-2);//協定時間に基づき日付を取得
        },
        /****************************************************************/
        // 選択された端末からプラン日数を取得して、
        // カレンダーの非活性範囲を指定する処理
        /****************************************************************/
        disabledDateChange() {
            // 日付を選択をアクティブにする
            document.querySelector('.datepicker input').style.border = '1px solid #5c5c5c'
            document.querySelector('.datepicker input').style.opacity = '1.0'
            document.querySelector('.datepicker_dp').style.background = 'none'
            document.getElementById('datepicker_focus_check').classList.add('datepicker-active')

            // ユーザーロール（role_id）がmanagerであればプラン期間外の表示を行う
            // ユーザー権限種別（auth_type_id）がuseradmin, user以外であればプラン期間外の表示をする
            // 以下の処理は、プラン期間内を表示するときに行う処理
            if(!this.$userRoleAuthorization('history', 'outOfRetentionPeriodRead') ||
               !this.$userAuthTypeAuthorization('history', 'outOfRetentionPeriodRead')) {
                // selectタブで選択されたカメラIDとカメラ名称を分割して格納
                this.temporarySelectedCamera = this.selectedCamera.split(',');
                // selectタブで選択されたカメラIDを抽出
                var termId = this.temporarySelectedCamera[0]

                for (var i = 0; i < this.cameraInfo.length; i++) {
                    if(termId === this.cameraInfo[i].term_id) {
                        // 選択されている端末IDと一致する端末IDのプラン日数を取得し、
                        // カレンダーの非活性範囲を指定する変数に格納
                        this.planDate = this.cameraInfo[i].plan_days
                    }
                }
            }
        },
        /**********************************************************/
        // サムネイル取得API実施
        /**********************************************************/
        // 引数
        // termId : 選択中の端末ID
        // siteNo : 端末グループNo
        /**********************************************************/
        getThumnailImageInfo(siteNo) {
            // selectタブで選択されたカメラIDとカメラ名称を分割して格納
            this.selectedCameraInfo = this.selectedCamera.split(',');
            // selectタブで選択されたカメラIDを抽出
            var termId = this.selectedCameraInfo[0]

            // 選択した日付をエラーチェック比較用に変換
            // vuejs-datepickerで選択された日付をformatPicker()を使ってフォーマットし、その値を抽出し、変数に代入
            var selectDay = this.formattedDate;//2021/01/05：指定した日付をとってくる
            var day = selectDay +' 00:00';//2021/01/05 00:00：時間をつけたす
            var dayDate = new Date(day);//Tue Jan 05 2021 00:00:00 GMT+0900 (日本標準時）：Date型で生成
            var datetime = dayDate.getTime();//1609772400000：経過ミリ秒（Unixtime）を取得

            // 今日の日付をエラーチェック比較用に変換
            var today = new Date(new Date().setHours(0, 0, 0, 0));
            var todaydatetime = today.getTime();

            if(termId == ""){
                // カメラを選択していない場合
                this.showResultMessage(
                    {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"入力エラー",
                        sub_message:"カメラを選択してください",
                        errorFlag: true
                    }
                );
            } else if(selectDay == ''){
                // 日付を選択していない場合
                this.showResultMessage(
                    {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"入力エラー",
                        sub_message:"日付を選択してください",
                        errorFlag: true
                    }
                );
            } else if(todaydatetime < datetime){
                // 今日の日付より後ろ（未来）の時刻の場合
                this.showResultMessage(
                    {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"入力エラー",
                        sub_message:"過去日を選択してください",
                        errorFlag: true
                    }
                );
            } else {
                window.history.pushState(null, null, this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo'] + '&term_id=' + this.selectedCameraInfo[0] + '&date=' + this.formattedDate.replace(/\//g, '-') + '&selected_type='  + this.selectedType);
                this.checkActiveMovie();


                this.$emit('loadStart');

                // 適用ボタンを2回目以降押下時に以前のサムネイルがある場合はリセットする
                if (this.historyList.length > 0) {
                    var cnt = 0;
                    for (var i = 0; i < this.historyList.length; i++) {
                        if(this.historyList[i].sequence !== 0) {
                            cnt++;
                        }
                    }
                    if (cnt !== 0) {
                        this.historyList = [];
                    }
                }

                var selectedTime = datetime;
                var time_start = day;
                var time_start_unixtime = Date.parse( time_start.replace( /-/g, '/') ) / 1000;
                this.timeStartUnixtime = time_start_unixtime;

                // アーカイブ用サムネイルAPIの実施
                var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
                this.$store.dispatch('requestApi/getApiInfoAction', {
                    // TODO: APIの構成を変更したため一旦違うjson名を指定
                    url: apiUrl + 'images/'+ siteNo +'/'+ termId +'/'+ time_start_unixtime + '/list',
                    params: queries
                }).then(response => {
                    if (todaydatetime === selectedTime) {
                        // this.historyList = [];
                        var todayHour = new Date().getHours();
                        // 現在時刻（h）までを格納
                        for (var i = 0; i <= todayHour; i++) {
                            this.$set(this.historyList, i, this.$store.getters['requestApi/getApiInfo'][i]);
                        }
                        this.historyList = this.historyList.reverse();
                    } else {
                        this.historyList = this.$store.getters["requestApi/getApiInfo"].reverse();
                    }

                    // 動画の空の配列作成
                    var count = 0;
                    this.is_thumbnailHourCount = 0;
                    for(var i in this.historyList) {
                        var list = this.historyList[i];
                        if (this.historyList[i].sequence !== 0) {
                            this.is_thumbnailHourCount++;
                        }
                        for (let step = 1; step <= list.sequence; step++) {
                            var datetime = list[step];
                            this.videoContinuousPlayList.splice(count, 1, [{"platform_term_id": termId,"endpoint_url": false}]);
                            count++;
                        }
                    }
                }, error => {// eslint-disable-line
                    // ローディングストップ
                    this.$emit('loadFinish');

                    window.history.pushState(null, null, this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo']);
                    if (error == "Error: Request failed with status code 401") {
                        sessionStorage.clear();
                        window.localStorage.removeItem('TodoApp');
                        this.showResultMessage(
                            {
                                transitionLogoutPageFlg: true,
                                transitionTopPageFlg: false,
                                execFlg: false,
                                message:"エラー",
                                sub_message:"トップページに戻ります。",
                                errorFlag: true
                            }
                        );
                    } else if (error == "Error: Request failed with status code 403") {
                        this.showResultMessage(
                            {
                                transitionLogoutPageFlg: false,
                                transitionTopPageFlg: true,
                                execFlg: false,
                                message:"権限エラー",
                                sub_message:"アクセス権がありません。",
                                errorFlag: true
                            }
                        );
                    } else {
                        this.showResultMessage(
                            {
                                transitionLogoutPageFlg: false,
                                transitionTopPageFlg: false,
                                execFlg: false,
                                message:"履歴取得エラー",
                                sub_message:"履歴が取得できませんでした。",
                                errorFlag: true
                            }
                        );
                    }
                })

                // 一括ダウンロード用の処理
                this.is_existOnedayDownloadData(siteNo, termId);
            }
        },

        /**********************************************************/
        // 動画取得API実施
        /**********************************************************/
        // 既に取得済みの動画URLを再取得しないようにチェックするため、
        // 取得したURLはvideListで管理
        /**********************************************************/
        // 引数
        // list          : 動画取得に必要な時刻を格納したもの
        // term_id       : 選択中の端末ID
        // selectedCameraThumbKey: 選択したサムネイルの番号
        // autoPlay      : true  = 通常再生 動画情報を全件管理しているvideListに取得情報を得た後、モーダルに渡すvideoUrlListへ入れる
        //                 false = 選択再生（連続再生） モーダルに渡すvideoUrlListへ入れる
        /**********************************************************/
        getArchiveVideo(list, term_id, selectedCameraThumbKey, autoPlay) {
            // 動画再生の終了時間
            var endingDateTime = list.datetime + list.endingTime;
            var queriesArchive = { live_access_token: this.$store.getters['auth/getLiveAccessToken'], platform_term_id: term_id,time_play_start: list.datetime, time_play_end: endingDateTime};

            this.$store.dispatch("requestApi/getApiInfoAction", {
                url: apiUrl + 'streams/archive/endpoint',
                params: queriesArchive
            }).then(response => {
                if(autoPlay){
                    this.videoContinuousPlayList.splice(selectedCameraThumbKey, 1, this.$store.getters["requestApi/getApiInfo"]);
                } else {
                    this.videoUrlList.splice(selectedCameraThumbKey, 1, this.$store.getters["requestApi/getApiInfo"]);
                }
            }, error =>{// eslint-disable-line
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"トップページに戻ります。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.modalClose();
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"映像取得エラー",
                        sub_message:"映像が取得できませんでした。",
                        errorFlag: true
                    });
                }
            }).finally(() => {
                this.selectedMovie = selectedCameraThumbKey;
                if(autoPlay){
                    this.videoUrlList = this.videoContinuousPlayList;
                }
            })
        },

        /**********************************************************/
        // ライブ再生 & モーダル開く
        /**********************************************************/
        // 子コンポーネント：LiveLists.vueで
        // サムネイルをクリックした時に動く関数 & モーダルを開く
        /**********************************************************/
        // 引数
        // selectVideo     : 選択したサムネイル番号の配列データ
        /**********************************************************/
        modalOpen(selectVideo) {
            // 複数選択が有効か判定
            if (this.is_multiSelect === true && this.is_continuousReproduction === false) {
                return;
            }
            // モーダルをopenさせる
            this.modal = true
            this.$nextTick(function () {
                componentScrollControl.no_scroll();
                componentModalCenter(".modal-window");
                document.getElementById('page_top').style.display = 'none';
                document.getElementById('Header').style.zIndex = "0";
            })

            window.history.pushState(null, null, this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo'] + '&term_id=' + this.selectedCameraInfo[0] + '&date=' + this.formattedDate.replace(/\//g, '-') + '&selected_type='  + this.selectedType + '&modal=open&key=' + selectVideo.key + '&term_id=' + selectVideo.term_id + '&datetime=' + selectVideo.datetime + '&endingTime=' + selectVideo.endingTime);

            // 選択された端末IDをオブジェクトに格納
            this.selectVideo = selectVideo;
            // var video = this.videoContinuousPlayList[selectVideo.key][0];
            // var url = video.endpoint_url;
            // 履歴画面のアーカイブ動画を再生させるために配置
            // 本来はurl変数の結果に応じて実行条件を分けたい
            this.getArchiveVideo(selectVideo, this.selectedCameraInfo[0], selectVideo.key,true);
        },

        /**********************************************************/
        // モーダル閉じる
        /**********************************************************/
        // modalデータをfalseにすることによってモーダルを閉じる
        // LiveModal.vue の 「@click.self="$emit('close')"」より実行
        /**********************************************************/
        modalClose() {
            this.modal = false
            this.is_continuousReproduction = false;
            this.is_endedMovie = false;
            window.history.pushState(null, null, this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo'] + '&term_id=' + this.selectedCameraInfo[0] + '&date=' + this.formattedDate.replace(/\//g, '-') + '&selected_type='  + this.selectedType);
            this.$nextTick(function () {
                document.getElementById('page_top').style.display = '';
                document.getElementById('Header').style.zIndex = '';
            })
        },

        /**********************************************************/
        // 静止画タブが押下されたかチェック
        /**********************************************************/
        // isActiveListImageをtrueにすることによって静止画一覧を表示する
        /**********************************************************/
        checkActiveImage() {
            this.isActiveListImage = true;
            this.isActiveListMovie = false;
        },

        /**********************************************************/
        // 動画タブが押下されたかチェック
        /**********************************************************/
        // isActiveListMovieをtrueにすることによって動画一覧を表示する
        /**********************************************************/
        checkActiveMovie() {
            this.isActiveListImage = false;
            this.isActiveListMovie = true;
        },

        /**********************************************************/
        // 連続再生が有効かチェック
        /**********************************************************/
        changeContinuousReproductionOption(flag) {
            this.is_continuousReproduction = flag;
        },

        /**********************************************************/
        // 連続再生時に次の動画を選択したかチェック
        /**********************************************************/
        checkEndedMovie(flag) {
            this.is_endedMovie = flag;
        },

        /**********************************************************/
        // 連続再生時に前の動画を選択したかチェック
        /**********************************************************/
        checkBackMovie(flag) {
            this.is_backMovie = flag;
        },

        /**********************************************************/
        // 実行結果を表示する処理
        /**********************************************************/
        showResultMessage(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result;
            this.errorFlag = result.errorFlag;
        },

        /**********************************************************/
        // 実行結果を表示するモーダルのボタンを押下した場合の処理
        /**********************************************************/
        confirmFinished() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg) {
                this.getThumnailImageInfo(this.siteInfo[0]['site_no']);
            }
        },

        /**********************************************************/
        // 一括ダウンロード対象のデータを取得
        /**********************************************************/
        is_existOnedayDownloadData(siteNo, termId) {
            // アーカイブ用サムネイルAPIの実施
            var queries = {
                live_access_token: this.$store.getters['auth/getLiveAccessToken'],
                time_play_start: this.timeStartUnixtime
            };
            this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + 'streams/download/'+ siteNo +'/'+ termId + '/status',
                params: queries
            }).then(response => {
                this.is_onedayDownloadButton = true;
                this.mediaFilesize = this.$store.getters["requestApi/getApiInfo"].media_filesize.replace(/\s+/g, "");;
            }, error => {// eslint-disable-line
                this.is_onedayDownloadButton = false;
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"トップページに戻ります。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                }
            })
        }
    },
    watch: {
        /**********************************************************/
        // 連続再生時に次の動画を再生
        /**********************************************************/
        is_endedMovie: {
            handler: function(){
                if (this.is_multiSelect === true && this.is_endedMovie === true) {
                    this.$refs.movieLists.chageNextMovie();
                    this.is_endedMovie = false;
                }
            },
            deep: true
        },

        /**********************************************************/
        // 連続再生時に前の動画を再生
        /**********************************************************/
        is_backMovie: {
            handler: function(){
                if (this.is_multiSelect === true && this.is_backMovie === true) {
                    this.$refs.movieLists.chageBackMovie();
                    this.is_backMovie = false;
                }
            },
            deep: true
        }
    },
    mounted() {
        // クエリパラメータをチェックしてLIVEモーダルを開いた状態から開始するか判定
        var url = location.pathname + location.search;
        var path = this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo'];
        var queries = componentUrlControl.url_check(url, path);
        if ('site_no' in queries &&  'term_id' in queries && 'date' in queries && 'selected_type' in queries) {
            if (this.cameraInfo !==  null) {
                this.formattedDate = queries.date.replace(/-/g, '/');
                this.selectedType = queries.selected_type;

                document.querySelector('.vdp-datepicker div input').value = queries.date.replace(/-/g, '/');

                for (var i = 0; i < this.cameraInfo.length; i++) {
                    if (this.cameraInfo[i].term_id === queries.term_id) {
                        this.selectedCamera = this.cameraInfo[i].term_id + ',' + this.cameraInfo[i].description;
                        break;
                    }
                }

                this.getThumnailImageInfo(Number(queries.site_no));

                if ('modal' in queries && 'key' in queries && 'datetime' in queries && 'endingTime' in queries) {
                    var selectVideo = {
                        key: 0, // 【TODO】元の番号だと映像が表示されないため要確認（0に固定すると動作する）
                        term_id: queries.term_id,
                        datetime: Number(queries.datetime),
                        endingTime: Number(queries.endingTime)
                    };
                    this.selectVideoModalOpen = selectVideo;

                }
            }
        } else {
            this.$emit('loadFinish');
        }

        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        componentHistoryTabSwitcher();

        /**********************************************************/
        // Datepickerを非表示(スマホ・タブレット用)
        // スマホ・タブレットでDatepickerを非表示にできないため(仕様)
        /**********************************************************/
        window.addEventListener('touchstart', (e) => {
            if(!e.target.closest('#datepicker_focus_check') && this.$refs.picker.isOpen) {
                this.closeDatepicker();
            }
        })
        /**********************************************************/
        // カメラ端末が一つしか存在しない場合、選択されている状態にする
        // カレンダーを選べる状態にする
        /**********************************************************/
        if (this.cameraInfo.length === 1) {
            // カメラを選択を選択されている状態にする
            this.selectedCamera = this.cameraInfo[0].term_id + ',' + this.cameraInfo[0].description;
            // 日付を選択をアクティブにする
            this.defaultSelected = false
            this.disabledDateChange()
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main/HistoryMain.css";
</style>